<p-toast></p-toast>
<p-messages key="batch-invoice-result"></p-messages>

<div class="grid p-fluid">
    <div class="col-12">
        <div class="card">
            <!-- <p-toolbar>
                <div class="p-toolbar-group-left">
                    <h5 class="m-0">Monthly Invoices</h5>
                </div>
            </p-toolbar> -->
            <p-table #invoiceTable [value]="invoices" [resizableColumns]="true" responsiveLayout="scroll"
                [paginator]="true" [rows]="150" [rowHover]="true" [totalRecords]="totalInvoices"
                [loading]="isInvoicelistLoading" sortField="id" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="grid">
                        <div class="col-8">
                            <div class="flex align-items-center gap-2">
                                <div>
                                    <p-dropdown [options]="searchOptions" [(ngModel)]="searchBy" optionLabel="name"
                                        optionValue="code" (onChange)="getSearchOptions($event)"
                                        [autoDisplayFirst]="false" appendTo="body" placeholder="Search By">
                                    </p-dropdown>
                                </div>
                                <div *ngIf="searchBy != 'all' && searchBy != 'Open'">
                                    <div class="grid" *ngIf="searchBy == 'billingMonth'">
                                        <div class="col-12">
                                            <p-calendar [(ngModel)]="searchByBillingMonth" view="month"
                                                [minDate]="minDate" dateFormat="mm/yy" [readonlyInput]="true"
                                                placeholder="Billing Month/Year"></p-calendar>
                                        </div>
                                    </div>
                                    <div class="grid" *ngIf="searchBy == 'date'">
                                        <div class="col-12">
                                            <p-calendar [(ngModel)]="searchByDate" [showIcon]="true" placeholder="Date"
                                                [readonlyInput]="true"></p-calendar>
                                        </div>
                                    </div>
                                    <div class="grid" *ngIf="searchBy == 'dateRange'">
                                        <div class="col-12">
                                            <p-calendar [(ngModel)]="searchByRangeDates" [showIcon]="true"
                                                selectionMode="range" [readonlyInput]="true"
                                                placeholder="Date"></p-calendar>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="searchBy == 'suite' || searchBy == 'suiteAcct' || searchBy == 'suiteOpen' || searchBy == 'suiteAcctOpen'">
                                        <div class="grid">
                                            <div
                                                [ngClass]="searchBy == 'suite' || searchBy == 'suiteOpen' ? 'col-12' : 'col-6'">
                                                <p-dropdown [options]="suiteOptions" [(ngModel)]="searchBySuite"
                                                    optionLabel="name" optionValue="code" appendTo="body"
                                                    placeholder="Select Suite" (onChange)="getAccountBySuite()">
                                                </p-dropdown>
                                            </div>
                                            <div class="col-6"
                                                *ngIf="searchBy == 'suiteAcct' || searchBy == 'suiteAcctOpen'">
                                                <p-dropdown [options]="suiteAcctOptions" [(ngModel)]="searchBySuiteAcct"
                                                    optionLabel="name" optionValue="code" appendTo="body"
                                                    placeholder="Select Account">
                                                </p-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p-button label="Search" (click)="searchInvoices()"
                                        [loading]="searchOptionsLoading || isInvoicelistLoading"
                                        [disabled]="searchOptionsLoading || isInvoicelistLoading"></p-button>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 flex align-items-center gap-2">
                            <input type="checkbox" id="selectAll" class="p-checkbox" [(ngModel)]="selectAll" (ngModelChange)="checkAllInvoice()">
                            <label for="selectAll" class="font-semibold">Select All</label>
                        </div>
                        <div class="col-2">
                            <p-button label="Process Output of {{getSelectedInvoiceCount}} Invoices"
                                [loading]="isProcessingInvoices" (onClick)="processBatchInvoices()"
                                [severity]="'success'">
                            </p-button>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pResizableColumn pSortableColumn="id">
                            Invoice
                            <p-sortIcon field="id"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="account">
                            Account
                            <p-sortIcon field="account"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="tenant">
                            Tenant
                            <p-sortIcon field="tenant"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="date">
                            Date
                            <p-sortIcon field="date"></p-sortIcon>
                        </th>
                        <th>Billing Month</th>
                        <th>Paid Date</th>
                        <th>Amount</th>
                        <th>Due</th>
                        <th>Type</th>
                        <th>Output</th>
                        <th>Batch</th>
                        <th>Void</th>
                        <th>Request Void</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-invoice>
                    <tr>
                        <td class="mpi-text-truncate">
                            <p-button [label]="invoice.id" [link]="true" (onClick)="viewInvoice(invoice.id)" />
                        </td>
                        <td class="mpi-text-truncate">{{ invoice.suite }} - {{ invoice.account }}</td>
                        <td class="mpi-text-truncate">{{ invoice.tenant }}</td>
                        <td class="mpi-text-truncate">{{ (invoice.date * 1000) | date:'MM/dd/yyyy' }}</td>
                        <td class="mpi-text-truncate">{{ invoice.billing_month }}</td>
                        <td>{{ invoice.paid_date ? ((invoice.paid_date * 1000) | date:'dd/MM/yyyy') : '' }}</td>
                        <td>{{ invoice.amt }}</td>
                        <td>{{ invoice.due }}</td>
                        <td>{{ invoice.type }}</td>
                        <td>
                            <input type="checkbox" class="p-checkbox"
                                [disabled]="invoice.output && invoice.batch_ran !== ''" [(ngModel)]="invoice.output">
                        </td>
                        <td>
                            @if(invoice.batch_ran) {
                                @if(invoice.batch_key == "") {
                                    Error {{ invoice.batch_desc }}
                                } @else if(invoice.batch_key == "Email") {
                                    Email sent. {{ invoice.batch_desc }}
                                } @else {
                                    <p-button label="Download Batch" [link]="true"
                                (onClick)="downloadBatchInvoice(invoice.id)" />
                                }
                            }
                        </td>
                        <td><p-button label="Void" [link]="true" (onClick)="voidInvoice(invoice.id)"/></td>
                        <td>
                            @if(invoice.void_pending == "Yes") {
                                <p-button label="Pending" styleClass="px-0 mx-0" [text]="true" severity="warning"/>
                            } @else {
                                <p-button label="Void" [link]="true" (onClick)="voidRequestClick($event, invVoidOverlayPanel)"/>
                                <p-overlayPanel #invVoidOverlayPanel appendTo="body" showCloseIcon="true" [style]="{'min-width': '400px'}">
                                    <div class="flex flex-column gap-2">
                                        <label for="hold-reason" class="label-required">Why is this invoice being voided? All voids will be approved by the central office before being completed.</label>
                                        <input pInputText  id="hold-reason" #holdReason />
                                    </div>
                                    <div class="w-full text-right p-2" >
                                        <p-button label="Save" [disabled]="!holdReason.value" (onClick)="requestVoid(invoice.id, holdReason.value, $event, invVoidOverlayPanel)"/>
                                    </div>
                                </p-overlayPanel>
                            }
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="9" class="text-center"><b>No Data Found.</b></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>